import { useEffect, useState } from 'react';

const useCountdownTimer = (durationSeconds, { startExpired = false } = {}) => {
  const [secondsRemaining, setSecondsRemaining] = useState(
    startExpired ? 0 : durationSeconds,
  );
  const [isExpired, setIsExpired] = useState(startExpired);

  useEffect(() => {
    setSecondsRemaining(startExpired ? 0 : durationSeconds);
    setIsExpired(startExpired);
    // startExpired is only read on mount and duration changes; don't re-run on its change alone
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [durationSeconds]);

  useEffect(() => {
    if (isExpired) {
      return;
    }

    const id = window.setInterval(() => {
      setSecondsRemaining((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          setIsExpired(true);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => {
      window.clearInterval(id);
    };
  }, [isExpired]);

  const reset = () => {
    setSecondsRemaining(durationSeconds);
    setIsExpired(false);
  };

  return { secondsRemaining, isExpired, reset };
};

export default useCountdownTimer;
